import {ChangeDetectionStrategy, Component, Inject, Injectable, Optional} from "@angular/core";
import {RANGE_DATE_CONTROLLER, RangeDateControllerDirective} from "../../entities";
import {DestroyStreamService} from "../../../../services";
import {map, takeUntil, tap} from "rxjs/operators";
import {Observable} from "rxjs";
import {startWith} from "rxjs/operators";


@Component({
  selector: 'int-range-calendar',
  templateUrl: './int-range-calendar.component.html',
  styleUrls: ['./int-range-calendar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    DestroyStreamService
  ]
})
export class IntRangeCalendarComponent {

  range$: Observable<{from: Date | null, to: Date | null}> = this.rangeController.range$
    .pipe(
      map((data: [Date | null, Date | null]) => {
        return {from: data[0] || null, to: data[1] || null};
      })
    )

  constructor(
    @Optional()
    readonly rangeController: RangeDateControllerDirective,
    private readonly destroy$: DestroyStreamService
  ) {
    if(!rangeController) {
      console.warn(`Please provide RangeDateControllerDirective use [RANGE_DATE_CONTROLLER]`)
    }
  }

  fromEventHandler(date: Date) {
    this.rangeController.setFrom(date)
  }

  toEventHandler(date: Date) {
    this.rangeController.setTo(date)
  }

  defaultDate() {
    return null
  }
}
